var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLettersRow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 545.368 280.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Letter_Container",
    x: 286.077,
    y: 34.217,
    width: 259.29,
    height: 246.738,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Letter_Container-2",
    x: 133.592,
    y: 8.017,
    width: 234.139,
    height: 206.72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Letter_Container-3",
    x: 0,
    y: 7.091,
    width: 217.681,
    height: 186.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "letters",
    transform: "matrix(0.851, 0.104, -0.393, 0.777, 81.772, -11.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R",
    transform: "translate(347.801 22.295)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11, -0.15, 0.56, 1.21, -431.62, 4.32)",
    filter: "url(#Letter_Container)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Letter_Container-4",
    "data-name": "Letter Container",
    width: 151.605,
    height: 214.031,
    rx: 22,
    transform: "matrix(0.85, 0.1, -0.39, 0.78, 368.91, 41.73)",
    fill: "#ffa726"
  })), /*#__PURE__*/React.createElement("text", {
    id: "e",
    transform: "translate(49.049 168.115)",
    fill: "#515151",
    fontSize: 159,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    id: "O",
    transform: "translate(173.9 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11, -0.15, 0.56, 1.21, -257.72, 26.61)",
    filter: "url(#Letter_Container-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Letter_Container-5",
    "data-name": "Letter Container",
    width: 151.605,
    height: 214.031,
    rx: 22,
    transform: "matrix(0.85, 0.1, -0.39, 0.78, 229.72, 6.24)",
    fill: "#ffca28"
  })), /*#__PURE__*/React.createElement("text", {
    id: "w",
    transform: "translate(30.098 169.115)",
    fill: "#515151",
    fontSize: 160,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "w"))), /*#__PURE__*/React.createElement("g", {
    id: "Letter",
    transform: "translate(0 -10.735)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11, -0.15, 0.56, 1.21, -83.82, 37.35)",
    filter: "url(#Letter_Container-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Letter_Container-6",
    "data-name": "Letter Container",
    width: 151.605,
    height: 214.031,
    rx: 22,
    transform: "matrix(0.85, 0.1, -0.39, 0.78, 77.39, -3.26)",
    fill: "#f44336"
  })), /*#__PURE__*/React.createElement("text", {
    id: "q",
    transform: "translate(29.984 168)",
    fill: "#fff",
    fontSize: 160,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "q"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLettersRow);
export default __webpack_public_path__ + "static/media/lettersRow.d09b26ba.svg";
export { ForwardRef as ReactComponent };